import React from 'react';
import MapViewControl from './MapView.Control.jsx';
import * as L from "leaflet";

import ExtraMarkers from 'leaflet-extra-markers';

import { MapContainer, TileLayer, Marker, Popup, Polyline, FeatureGroup, useMap, Tooltip } from 'react-leaflet'
function getLineColour(distance) {
    switch (distance) {
        case 50:
            return "#ff99cc";
        case 100:
            return "#99ccff";
        case 150:
            return "#cc99cc";
        case 200:
            return "#d83c3d";
        case 300:
            return "#ffcc00";
        case 400:
            return "#339933";
        case 600:
            return "#006699";
        case 1000:
            return "#999999";
        default:
            return "#000000";
            break;
    }
}

export default function MapViewRide(props) {
    const parentMap = useMap(); 
    
    var ride = props.ride;
    var isSelected = props.isSelected;
    var markers = [];
    const lineOptions = { color: getLineColour(ride.NominalDistance) }

    var stages = [];
    var firstStageStart = null;
    var markers = [];
    for (let i = 0; i < ride.Checkpoints.length; i++) { 
        var checkPointData = ride.Checkpoints[i];
        var myPoint = [checkPointData.Point.Latitude, checkPointData.Point.Longitude];
        if (firstStageStart == null) {
            firstStageStart = myPoint;
        }

        stages.push(myPoint);
        if (isSelected) {
            var markerText = "";
            var markerIcon = null; L.ExtraMarkers.icon({
                icon: 'fa-coffee',
                markerColor: 'red',
                shape: 'square',
                prefix: 'fa'
            });
            switch(checkPointData.Type){
                case 0:
                    markerText="Start";
                    markerIcon= L.ExtraMarkers.icon({
                        icon: 'fa-play',
                        markerColor: 'green',
                        shape: 'circle',
                        prefix: 'fa',
                        extraClasses:"g-pl-5"
                    });
                    break;
                case 1:
                    markerText="End";
                    markerIcon= L.ExtraMarkers.icon({
                        icon: 'fa-stop',
                        markerColor: 'red',
                        shape: 'circle',
                        prefix: 'fa',
                        extraClasses:""
                    });
                    break;
                case 2:
                    markerText="Checkpoint";
                    markerIcon= L.ExtraMarkers.icon({
                        icon: 'fa-check-circle',
                        markerColor: 'cyan',
                        shape: 'penta',
                        prefix: 'fa'
                    });
                    break;
                case 3:
                    markerText="Start Or End";
                    markerIcon= L.ExtraMarkers.icon({
                        icon: 'fa-step-forward',
                        markerColor: 'green',
                        shape: 'circle',
                        prefix: 'fa',
                        extraClasses:""
                    });
                    break;         
            }
        
            var marker = <Marker position={myPoint} key={i} icon={markerIcon}>
                <Tooltip>
                    {markerText}
                </Tooltip>
            </Marker>
            markers.push(marker);
        } 
    }

    if (ride.IsCicular) {
        stages.push(firstStageStart);
    }
    var viewControl = null;
    if (isSelected) {
        viewControl = <MapViewControl ride={ride} close={props.close} />;
       // parentMap.fitBounds(stages);
    }
    return (
        <FeatureGroup pathOptions={lineOptions} key={ride.Id} eventHandlers={{ click: (evt) => props.open(evt, ride.Id), popupclose: props.close }}>
            {viewControl}
            {markers}
            <Polyline pathOptions={lineOptions} positions={stages} />
        </FeatureGroup>);

}
